import {
  browserMatchesClinicZone,
  clinicZoneShortLabel,
  formatInstantInBrowserZone,
  formatInstantInClinicZone,
} from "@/lib/clinicTime";

const DATE_PATTERN = "EEE, d MMM yyyy · h:mm a";
const TIME_PATTERN = "h:mm a";

/**
 * Renders a slot start instant as a single line that is unambiguous
 * regardless of the viewer's time zone.
 *
 * <p>The clinic zone is the <b>authoritative</b> wall-clock for ChikitsaLink
 * (Asia/Kolkata by default), so we lead with it and append the viewer's
 * browser-zone rendering as a parenthetical hint when they differ. When
 * they match, only the clinic rendering is returned.
 */
export function formatSlotStart(
  isoInstant: string,
  timeZone?: string | null,
): string {
  const d = new Date(isoInstant);
  if (Number.isNaN(d.getTime())) return isoInstant;
  if (browserMatchesClinicZone(timeZone)) {
    return formatInstantInClinicZone(d, DATE_PATTERN, timeZone);
  }
  const clinic = formatInstantInClinicZone(d, DATE_PATTERN, timeZone);
  const label = clinicZoneShortLabel(timeZone);
  const browser = formatInstantInBrowserZone(d, TIME_PATTERN);
  return `${clinic} ${label}  (${browser} in your zone)`;
}

/**
 * Same as {@link formatSlotStart} but only the clock-time component.
 */
export function formatSlotTime(
  isoInstant: string,
  timeZone?: string | null,
): string {
  const d = new Date(isoInstant);
  if (Number.isNaN(d.getTime())) return isoInstant;
  if (browserMatchesClinicZone(timeZone)) {
    return formatInstantInClinicZone(d, TIME_PATTERN, timeZone);
  }
  const clinic = formatInstantInClinicZone(d, TIME_PATTERN, timeZone);
  const label = clinicZoneShortLabel(timeZone);
  const browser = formatInstantInBrowserZone(d, TIME_PATTERN);
  return `${clinic} ${label}  (${browser} in your zone)`;
}
